import React, { useMemo } from "react";
import PropTypes from "prop-types";

import { Icon } from "../Icon";

export const Button = ({
  backgroundColor,
  color,
  size,
  minWidth,
  fitWidth,
  label,
  disabled,
  icon,
  uppercase,
  ...props
}) => {
  const { href } = props;

  const body = useMemo(() => {
    return (
      <>
        {icon && (
          <span className="Button__prepend">
            <Icon icon={icon} />
          </span>
        )}
        {label}
      </>
    );
  }, [label, icon]);

  const className = useMemo(() => {
    const classes = ["Button"];

    classes.push(`Button--${size}`);

    if (disabled) classes.push("Button--disabled");
    if (minWidth) classes.push("Button--minWidth");
    if (fitWidth) classes.push("Button--fitWidth");
    if (uppercase) classes.push("Button--uppercase");

    return classes.join(" ");
  }, [disabled, size, minWidth, fitWidth, uppercase]);

  const colors = {
    backgroundColor,
    color,
  };

  return href ? (
    <a className={className} style={colors} {...props}>
      {body}
    </a>
  ) : (
    <button type="button" className={className} style={colors} {...props}>
      {body}
    </button>
  );
};

Button.propTypes = {
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  label: PropTypes.string.isRequired,
  minWidth: PropTypes.bool,
  fitWidth: PropTypes.bool,
  size: PropTypes.oneOf(["regular", "small"]),
  disabled: PropTypes.bool,
  uppercase: PropTypes.bool,
  icon: PropTypes.string,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  backgroundColor: null,
  color: null,
  icon: undefined,
  onClick: undefined,
  disabled: false,
  minWidth: false,
  fitWidth: true,
  size: "regular",
  uppercase: true,
};
